export const SET_CUSTOMER_TYPE = "appState/SET_CUSTOMER_TYPE";
export const SET_PRODUCT_SELECTION = "appState/SET_PRODUCT_SELECTION";
export const SET_GAS_AVAILABILITY = "appState/SET_GAS_AVAILABILITY";
export const SET_GAS_SELECTION = "appState/SET_GAS_SELECTION";
export const SET_PLAN_USAGE_TYPE = "appState/SET_PLAN_USAGE_TYPE";
export const SUBMIT_OCCUPANCY_FORM = "appState/SUBMIT_OCCUPANCY_FORM";
export const SUBMIT_PLAN_SELECT_FORM = "appState/SUBMIT_PLAN_SELECT_FORM";
export const UPDATE_PRODUCT_SELECTION = "appState/UPDATE_PRODUCT_SELECTION";
export const SET_RECENTLY_FAILED_API = "appState/SET_RECENTLY_FAILED_API";
